import React from "react";
import {
  ClosestPatient,
  PatientsNearby,
  PatientsNearbyDetailsWrapper,
} from "../../../AddMember.style";
import { getMilesFromMeters, useTranslation } from "hhn-commons";
import { IUserInfo } from "@home-health-notify/domain";
import PersonIcon from "@mui/icons-material/Person";
import { NearMe } from "@mui/icons-material";

const PatientsNearbyDetails = ({ userInfo }: { userInfo: IUserInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <PatientsNearbyDetailsWrapper>
      <PatientsNearby data-testid="patients-nearby">
        <PersonIcon fontSize="small" />
        {tNs("advancedSearch.nearby")}
        {userInfo.patientsNearby}
      </PatientsNearby>
      {userInfo.closestPatient && (
        <ClosestPatient data-testid="closest-patient">
          <NearMe fontSize="small" />
          {tNs("advancedSearch.closest")}
          {getMilesFromMeters(userInfo.closestPatient.distance)}
          {tNs("smartContent.miles")}
        </ClosestPatient>
      )}
    </PatientsNearbyDetailsWrapper>
  );
};

export default PatientsNearbyDetails;
